import {
    BOOKING_CONFIG_LOADED,
    BOOKING_CONFIG_LOADED_FOR_AMENITY_SUMMARY,
    BOOKING_CONFIG_LOADED_FOR_FORM,
    BOOKING_CONFIG_REQUESTED, BOOKING_CONFIRMED,
    BOOKING_UPDATED,
} from "./BookingGlobalActions";
import { dateFromState, dateToState, } from "../../../Helpers/DateTimeHelper";
import { max, startOfDay, startOfHour, subHours } from "date-fns";
import { SELECT_AMENITY_VIEWMODE } from "../Bookings";


export const BOOKINGS_SET_AMENITY_VIEWMODE = 'bookings/form/BOOKINGS_SET_AMENITY_VIEWMODE';
export const BOOKING_FORM_CATEGORIES_LOADED = 'bookings/form/BOOKING_FORM_CATEGORIES_LOADED';
export const BOOKING_FORM_CATEGORY_LOADED = 'bookings/form/BOOKING_FORM_CATEGORY_LOADED';
export const BOOKING_FORM_AMENITY_LOADED = 'bookings/form/BOOKING_FORM_AMENITY_LOADED';
export const BOOKING_FORM_VALUE_CHANGED = 'bookings/form/BOOKING_VALUE_CHANGED';
export const BOOKING_FORM_VALUES_CHANGED = 'bookings/form/BOOKING_VALUES_CHANGED';
export const BOOKING_FORM_DATE_CHANGED = 'bookings/form/BOOKING_DATE_CHANGED';
export const EDIT_BOOKING_LOADED = 'bookings/form/EDIT_BOOKING_LOADED';
export const BOOKING_TIME_SELECTED_FOR_AMENITY = 'bookings/form/BOOKING_TIME_SELECTED_FOR_AMENITY';
export const BOOKING_FORM_ERRORS_RETURNED = 'bookings/form/BOOKING_FORM_ERRORS_RETURNED';
export const BOOKINGS_SET_TAG_FILTER = 'bookings/form/BOOKINGS_SET_TAG_FILTER';
export const BOOKING_FLOW_RESET = 'bookings/global/BOOKING_FLOW_RESET';
export const BOOKING_FORM_RESET = 'bookings/form/BOOKING_FORM_RESET';

export const SAVE_BOOKING_FOR_RESTORE = 'bookings/form/SAVE_BOOKING_FOR_RESTORE';
export const RESTORE_BOOKING_LOADED = 'bookings/form/RESTORE_BOOKING_LOADED';

function getDefaultDate() {
    const date = new Date();
    // Get the previous 4-hour interval
    const defaultDate = startOfHour(subHours(date, date.getHours() % 4));
    const previousMidnight = startOfDay(date);
    return dateToState(max([defaultDate, previousMidnight]));
}

export const initialState = {
    categories: false,
    category: false,
    amenities: false,
    amenity: false,
    date: getDefaultDate(),
    bookingConfig: false,
    bookingConfigsLoading: false,

    tags: false,

    confirmedBookingId: false,
    editBookingId: false,
    restoreBookingId: null,

    savedAmenityViewMode: SELECT_AMENITY_VIEWMODE.LIST,

    booking: {
        id: null,
        slug: null,
        parent_id: null,

        category_id: null,
        amenity_id: null,

        user_id: null,
        user_name: null,
        unit_id: null,
        unit_name: null,

        start: '',
        end: '',
        notes: '',
        signed_in_note: null,
        terms_accepted: false,

        recurrence: {},
        rescheduled_occurrences: {},

        visitors: [],
        visitors_added: null,
        visitors_notes: '',

        form: {},
    },

    errors: {},

};

export const saveAmenityViewMode = (amenityViewMode) => ({
    type: BOOKINGS_SET_AMENITY_VIEWMODE,
    payload: {
        amenityViewMode
    }
});

export const bookingFormValueChanged = (field, value) => ({
    type: BOOKING_FORM_VALUE_CHANGED,
    payload: {
        field: field,
        value: value,
    }
});
export const bookingFormValuesChanged = (values) => ({
    type: BOOKING_FORM_VALUES_CHANGED,
    payload: {
        values: values,
    }
});
export const bookingFormDateChanged = (date) => ({
    type: BOOKING_FORM_DATE_CHANGED,
    payload: {
        date: date,
    }
});

export const editBookingLoaded = (booking, amenity, category, bookingConfig) => ({
    type: EDIT_BOOKING_LOADED,
    payload: {
        booking: booking,
        amenity: amenity,
        category: category,
        bookingConfig: bookingConfig,
        date: bookingConfig.availability.date
    }
});

/**
 * To be dispatched when user chooses a time on the amenity select page
 * and transitions to the booking form proper
 * @param start
 * @param end
 */
export const bookingTimeSelectedForAmenity = (start, end) => ({
    type: BOOKING_TIME_SELECTED_FOR_AMENITY,
    payload: {
        start: start,
        end: end,
    }
});

export const bookingFormErrorsReturned = (errors) => ({
    type: BOOKING_FORM_ERRORS_RETURNED,
    payload: {
        errors: errors
    }
});

export const bookingFormCategoriesLoaded = (payload) => ({
    type: BOOKING_FORM_CATEGORIES_LOADED,
    payload
});

export const bookingFormCategoryLoaded = (category, amenities) => ({
    type: BOOKING_FORM_CATEGORY_LOADED,
    payload: { category, amenities }
});

export const bookingFormAmenityLoaded = (amenity) => ({
    type: BOOKING_FORM_AMENITY_LOADED,
    payload: {
        amenity
    }
});

export const setTagFilter = (tags) => ({
    type: BOOKINGS_SET_TAG_FILTER,
    payload: {
        tags
    }
});

export const resetBookingFlow = () => ({
    type: BOOKING_FLOW_RESET,
})
export const resetBookingForm = (keepUserAndUnit = false) => ({
    type: BOOKING_FORM_RESET,
    payload: {
        keepUserAndUnit
    }
});

export const saveBookingForRestore = (bookingId) => ({
    type: SAVE_BOOKING_FOR_RESTORE,
    payload: {
        bookingId
    },
})


export const restoreBookingLoaded = (booking, amenity, category, bookingConfig) => ({
    type: RESTORE_BOOKING_LOADED,
    payload: {
        booking: booking,
        amenity: amenity,
        category: category,
        bookingConfig: bookingConfig,
        date: bookingConfig.availability.date
    }
});

export const BookingFormReducer = (state = initialState, action) => {
    switch (action.type) {

        case BOOKING_FORM_CATEGORIES_LOADED: {
            return {
                ...state,
                categories: action.payload
            }
        }

        case BOOKING_FORM_CATEGORY_LOADED: {
            return {
                ...state,
                category: action.payload.category,
                amenities: action.payload.amenities,
                bookingConfigsLoading: false,
            }
        }

        case BOOKING_FORM_AMENITY_LOADED: {
            return {
                ...state,
                amenity: action.payload.amenity,
                bookingConfig: false,
            }
        }

        case BOOKINGS_SET_AMENITY_VIEWMODE: {
            return {
                ...state,
                savedAmenityViewMode: action.payload.amenityViewMode
            }
        }

        case BOOKING_CONFIG_REQUESTED: {
            return {
                ...state,
                bookingConfigsLoading: true,
            }
        }

        case BOOKING_CONFIG_LOADED: {
            return {
                ...state,
                bookingConfigsLoading: false,
            }
        }

        case BOOKING_CONFIG_LOADED_FOR_AMENITY_SUMMARY: {
            return {
                ...state,
                bookingConfigsLoading: false,
            }
        }

        case BOOKING_CONFIG_LOADED_FOR_FORM: {
            return {
                ...state,
                category: action.payload.category,
                amenity: action.payload.amenity,
                bookingConfig: action.payload.bookingConfig,
                bookingConfigsLoading: false,
                booking: {
                    ...state.booking,
                    category_id: action.payload.category?.id ?? null,
                    amenity_id: action.payload.amenity?.id ?? null
                }
            }
        }

        case EDIT_BOOKING_LOADED: {
            return {
                ...state,
                category: action.payload.category,
                amenity: action.payload.amenity,
                bookingConfig: action.payload.bookingConfig,
                booking: action.payload.booking,
                date: action.payload.date,
            }
        }

        case BOOKING_FLOW_RESET: {
            return {
                ...state,
                category: initialState.category,
                amenity: initialState.amenity,
                bookingConfig: initialState.bookingConfigsLoading,
                booking: { ...initialState.booking },
                date: getDefaultDate(),
                confirmedBookingId: initialState.confirmedBookingId,
            }
        }

        case BOOKING_FORM_RESET: {
            const newBookingState = {
                ...initialState.booking
            };

            if (action.payload.keepUserAndUnit) {
                newBookingState.user_id = state.booking.user_id;
                newBookingState.unit_id = state.booking.unit_id;
            }

            return {
                ...state,
                date: getDefaultDate(),
                amenity: false,
                bookingConfig: false,
                booking: newBookingState,
            };
        }

        case BOOKING_TIME_SELECTED_FOR_AMENITY: {
            return {
                ...state,
                date: dateToState(startOfDay(dateFromState(action.payload.start))),
                booking: {
                    ...state.booking,
                    ...initialState.booking,

                    user_id: state.booking.user_id,
                    unit_id: state.booking.unit_id,
                    start: action.payload.start,
                    end: action.payload.end,
                    category_id: null,
                    amenity_id: null,
                    okkami_timeslot_id: action.payload.okkami_timeslot_id,
                }
            }
        }

        case BOOKING_FORM_VALUE_CHANGED: {
            return {
                ...state,
                booking: {
                    ...state.booking,
                    [action.payload.field]: action.payload.value
                }
            }
        }

        case BOOKING_FORM_VALUES_CHANGED: {
            return {
                ...state,
                booking: {
                    ...state.booking,
                    ...action.payload.values
                }
            }
        }

        case BOOKING_FORM_DATE_CHANGED: {
            let updated = {
                ...state,
                date: action.payload.date,
                booking: {
                    ...state.booking,
                    recurrence: {},
                    rescheduled_occurrences: {},
                },
                bookingConfig: {
                    ...state.bookingConfig,
                    availability: {
                        ...state.bookingConfig.availability ?? null,
                    }
                }
            }

            // If we are making a fixed booking, then clear the selected booking
            // interval as it will probably be on different day.
            // We can keep a variable booking in place as bookings on other
            // days can still be shown on the timeline
            if (!updated.bookingConfig.is_variable) {
                updated.booking = {
                    ...state.booking,
                    start: initialState.booking.start,
                    end: initialState.booking.end,
                };
            }

            return updated;
        }

        case BOOKING_FORM_ERRORS_RETURNED: {
            return {
                ...state,
                errors: action.payload.errors
            }
        }

        case BOOKING_UPDATED: {
            return {
                ...state,
                bookingUpdated: action.payload
            }
        }

        case BOOKING_CONFIRMED: {
            return {
                ...state,
                confirmedBookingId: action.payload.booking.slug,
            }
        }

        case BOOKINGS_SET_TAG_FILTER: {
            return {
                ...state,
                tags: action.payload.tags,
            }
        }

        case SAVE_BOOKING_FOR_RESTORE: {
            return {
                ...state,
                restoreBookingId: action.payload.bookingId
            }
        }

        case RESTORE_BOOKING_LOADED: {
            const restoreBooking = action.payload.booking;

            return {
                ...state,
                category: action.payload.category,
                amenity: action.payload.amenity,
                bookingConfig: action.payload.bookingConfig,
                booking: {
                    id: null,
                    slug: null,
                    parent_id: null,

                    category_id: restoreBooking.category_id,
                    amenity_id: restoreBooking.amenity_id,

                    user_id: restoreBooking.user_id,
                    user_name: restoreBooking.user_name,
                    unit_id: restoreBooking.unit_id,
                    unit_name: restoreBooking.unit_name,

                    start: restoreBooking.start,
                    end: restoreBooking.end,
                    notes: restoreBooking.notes,
                    signed_in_note: restoreBooking.signed_in_note,
                    terms_accepted: false,

                    recurrence: {},
                    rescheduled_occurrences: {},

                    visitors: restoreBooking.visitors,
                    visitors_added: restoreBooking.visitors_added,
                    visitors_notes: restoreBooking.visitors_notes,

                    form: restoreBooking.form,
                },
                date: action.payload.date,

                restoreBookingId: null,
            }
        }

        default:
            return state;
    }
}
